import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Injectable, inject} from '@angular/core';
import {UIConfiguration} from './uiconfiguration';
import {FilterResult} from '../../resource/filterresult';
import {BaseApiService} from '../../core/services/base-api.service';
import {SupportedLocaleConfigurationService} from './supportedlocaleconfiguration.service';

@Injectable()
export class UIConfigurationService extends BaseApiService {
  private localeService = inject(SupportedLocaleConfigurationService);

  public getUIConfiguration(): Observable<UIConfiguration> {
    const attributes = [
      this.getAttr('ObjectID'),
      this.getAttr('DisplayName'),
      this.getAttr('StringResources'),
      this.getAttr('MaintenanceMode'),
      this.getAttr('Info'),
      this.getAttr('Email'),
      this.getAttr('DowntimeInfo'),
      this.getAttr('TimeZone'),
      this.getAttr('UseDescription'),
      this.getAttr('UseHint'),
      this.getAttr('DevEnvironment'),
      this.getAttr('Color'),
      this.getAttr('Theme'),
      this.getAttr('TextColor'),
      this.getAttr('SiteTitle'),
      this.getAttr('PrimaryColor'),
      this.getAttr('AccentColor'),
      this.getAttr('WarnColor'),
    ].filter(attr => attr !== null);

    return this.getWithLocale<FilterResult>(
      '/' + this.getType('UIConfiguration'),
      attributes,
      1,
      this.localeService.getSupportedLocaleConfiguration(),
    ).pipe(map(response => this.toUIConfiguration(response.Results)));
  }

  private toUIConfiguration(uiconfs: any): UIConfiguration {
    if (Array.isArray(uiconfs) && uiconfs.length == 1) {
      return this.toSingleUIConfiguration(uiconfs[0]);
    } else {
      throw 'UIConfigurationService::toUIConfiguration invalid attribute given.';
    }
  }

  private toSingleUIConfiguration(r: any): UIConfiguration {
    return <UIConfiguration>{
      id: r[this.getAttr('ObjectID')],
      displayname: r[this.getAttr('DisplayName')],
      stringresources: r[this.getAttr('StringResources')],
      maintenancemode: r[this.getAttr('MaintenanceMode')],
      info: r[this.getAttr('Info')],
      email: r[this.getAttr('Email')],
      downtimeinfo: r[this.getAttr('DowntimeInfo')],
      timezone: r[this.getAttr('TimeZone')],
      usedescription: r[this.getAttr('UseDescription')],
      usehint: r[this.getAttr('UseHint')],
      devenvironment: r[this.getAttr('DevEnvironment')],
      color: r[this.getAttr('Color')],
      theme: r[this.getAttr('Theme')],
      textcolor: r[this.getAttr('TextColor')],
      sitetitle: r[this.getAttr('SiteTitle')],
      primarycolor: r[this.getAttr('PrimaryColor')],
      accentcolor: r[this.getAttr('AccentColor')],
      warncolor: r[this.getAttr('WarnColor')],
    };
  }
}
